import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { PluginContextProvider } from '#pplx/frontend/composer-sdk/internal/plugins/pluginContext.js';
import React, { useMemo, useState } from 'react';
/** Renders every placement of one slot, each under its own plugin context. */
export const SlotHost = function SlotHost({ placements }) {
    // Give each placement the context its component will read through usePlugin().
    // Memoized so we don't hand children new objects (and re-render them) every tick.
    const bound = useMemo(() => {
        const counts = new Map();
        return (placements ?? []).map((placement) => {
            const index = counts.get(placement.pluginId) ?? 0;
            counts.set(placement.pluginId, index + 1);
            return {
                // A plugin can contribute more than once to this slot. Count within the plugin
                // so adding or removing a neighbor does not change a contribution's identity.
                key: `${placement.pluginId}:${index}`,
                Component: placement.component,
                context: { pluginId: placement.pluginId },
                props: placement.props ?? {},
                visible: placement.visible,
            };
        });
    }, [placements]);
    const visibleIds = bound.filter(({ visible }) => visible !== false).map(({ key }) => key);
    // Retain only outgoing contributors during the last row's collapse; previously
    // hidden neighbors must not reappear while the whole region closes.
    const [lastVisibleIds, setLastVisibleIds] = useState(visibleIds);
    if (visibleIds.length > 0 &&
        (visibleIds.length !== lastVisibleIds.length ||
            visibleIds.some((id, index) => id !== lastVisibleIds[index]))) {
        setLastVisibleIds(visibleIds);
    }
    if (bound.length === 0) {
        return null;
    }
    return (_jsx(_Fragment, { children: bound.map(({ Component, context, props, visible, key }) => {
            const hidden = visible === false && (visibleIds.length > 0 || !lastVisibleIds.includes(key));
            return (_jsx(PluginContextProvider, { value: context, children: visible === undefined ? (_jsx(Component, { ...props })) : (_jsx("div", { hidden: hidden, "aria-hidden": !visible || undefined, inert: !visible || undefined, className: hidden ? undefined : 'contents', children: _jsx(Component, { ...props }) })) }, key));
        }) }));
};
//# sourceMappingURL=SlotHost.js.map